import Vue from 'vue';

const groups = new Map();

const textareaSync = {
  register(group, textarea) {
    if (!group || !textarea) return;

    if (!groups.has(group)) {
      groups.set(group, new Set());
    }

    groups.get(group).add(textarea);

    // Initial sync
    this.update(group);
  },

  unregister(group, textarea) {
    if (!group || !textarea) return;

    const set = groups.get(group);

    if (!set) return;

    set.delete(textarea);

    if (set.size === 0) {
      groups.delete(group);
      return;
    }

    this.update(group);
  },

  update(group) {
    const set = groups.get(group);

    if (!set) return;

    let maxHeight = 0;

    // Measure
    set.forEach((textarea) => {
      textarea.style.height = 'auto';
      maxHeight = Math.max(maxHeight, textarea.scrollHeight);
    });

    // Apply
    set.forEach((textarea) => {
      textarea.style.height = `${maxHeight}px`;
    });
  },
};

Vue.prototype.$textareaSync = textareaSync;

export default textareaSync;
